module.exports = __webpack_public_path__ + "0b2e2aca9a42980ad6fd09b9dbc130d4.MP3";